import md5 from 'md5'
let env_str = 'szyc_' + md5(location.host + process.env.VUE_APP_BASE_API).slice(0, 4) + '_'
export const storageList = {
  last_edit_brand: env_str + 'last_edit_brand'
}